// extracted by mini-css-extract-plugin
export default {"notification":"Notifications_notification__pwlBH"};